import { FC } from 'react';
import { FarmPageFragment } from '../../../generated/types';
import { Container, Heading } from '@chakra-ui/react';
import { ParagraphRenderer } from '../../Paragraph/ParagraphRenderer';
import { Metatags } from '../../Layout/Metatags';
import { FarmPremiumMenu } from '../Farm/FarmPremiumMenu';
import { FarmHeader } from '../Farm/FarmHeader';
import { FarmRatings } from '../Farm/FarmRatings';
import { FarmContact } from '../Farm/FarmContact';
import { FarmContext } from '../../../context/FarmContext';

interface FarmPageProps {
  data: FarmPageFragment;
}

export const FarmPage: FC<FarmPageProps> = ({ data }) => {
  return (
    <>
      <Metatags metatags={data.metatags} />
      <FarmHeader data={data.farm} />
      <FarmPremiumMenu data={data.farm} />
      <FarmContext.Provider
        value={{
          farm: data.farm,
        }}
      >
        <ParagraphRenderer
          paragraphs={data.content}
          wrapperProps={{
            py: 0,
          }}
        />
      </FarmContext.Provider>
      <FarmRatings data={data.farm} />
      <FarmContact data={data.farm} />
    </>
  );
};
